import React from 'react'
import PropTypes from 'prop-types'
import escapeHtml from 'escape-html'
import clsx from 'clsx'
import { Text } from 'slate'
import { XlsIcon, DocIcon, PdfIcon, DownloadIcon, DeleteIcon } from '@ow/icons'
import {
  StyledFileDetail,
  StyledFileLeft,
  StyledTime,
  StyledContent,
  StyledIconFile,
  StyledContentHtml,
} from './styled/file'
import RenderIf from '../render-if'
import FilePreview from '../file-preview'

const getThumbnail = (url) => {
  if (url.indexOf('ow-prod.oss-') > -1 || url.indexOf('ow-prod-cdn') > -1) {
    const position = url.indexOf('?Expires=')
    return `${
      position === -1 ? url : url.slice(0, position)
    }?x-oss-process=image/resize,h_270,m_lfit`
  }
  return url
}
// 序列化-将编辑器的数据格式转为HTML
const serializeToHtml = (node) => {
  if (Text.isText(node)) {
    let string = escapeHtml(node.text)
    if (node.bold) {
      string = `<strong>${string}</strong>`
    }
    if (node.code) {
      string = `<code>${string}</code>`
    }
    if (node.italic) {
      string = `<em>${string}</em>`
    }
    if (node.underline) {
      string = `<u>${string}</u>`
    }
    if (node.color) {
      string = `<span style='color: ${node.color}'>${string}</span>`
    }
    return string
  }

  const children =
    node.children && node.children.map((n) => serializeToHtml(n)).join('')

  let content = ''
  switch (node.type) {
    // 有序列表
    case 'numbered-list':
      content = `<ul style='list-style: decimal; padding-left: 40px; margin: 16px 0;'>
        ${(node.children || [])
          .map((m) => {
            return `<li>${m.children.map((item) => serializeToHtml(item))}</li>`
          })
          .join('')}
      </ul>`
      break
    // 无序列表
    case 'bulleted-list':
      content = `<ol style='list-style: disc; padding-left: 40px; margin: 16px 0;'>
        ${(node.children || [])
          .map((m) => {
            return `<li>${m.children.map((item) => serializeToHtml(item))}</li>`
          })
          .join('')}
      </ol>`
      break
    // 一级标题
    case 'heading-one':
      content = `<h1 style='font-size:32px;font-weight: 800;line-height: ${
        node.lineHeight || 'normal'
      };text-align:${node.align || 'left'}'>${children}</h1>`
      break
    // 二级标题
    case 'heading-two':
      content = `<h2 style='font-size:24px;font-weight: 800;line-height: ${
        node.lineHeight || 'normal'
      };text-align:${node.align || 'left'}'>${children}</h2>`
      break
    // 引用
    case 'block-quote':
      content = `<blockquote style='font-style: italic; border-left: 2px solid #ddd; color: #aaa;'>${children}</blockquote>`
      break
    case 'quote':
      content = `<blockquote><p>${children}</p></blockquote>`
      break
    case 'paragraph':
      content = `<p style='text-align: ${node.align || 'left'};line-height: ${
        node.lineHeight || '32px'
      }'>${children}</p>`
      break
    case 'indent':
      content = `<p style='text-indent: 2em;line-height: ${node.lineHeight}'>${children}</p>`
      break
    case 'link':
      content = `<img src=${getThumbnail(
        node.url
      )} alt="" style="display:block;width:100%" />`
      break
    default:
      content = children
      break
  }

  return content
}
const renderConent = (contentArr) => {
  const htmlVal = contentArr.map((v) => {
    return serializeToHtml(v)
  })
  return htmlVal.join('')
}
const renderIcon = (extname) => {
  let iconComps
  switch (extname) {
    case 'xlsx':
    case 'xls':
      iconComps = <XlsIcon width={100} height={100} />
      break
    case 'doc':
    case 'docx':
      iconComps = <DocIcon width={100} height={100} />
      break
    case 'pdf':
      iconComps = <PdfIcon width={100} height={100} />
      break
    default:
      iconComps = <PdfIcon width={100} height={100} />
      break
  }
  return iconComps
}

const File = (props) => {
  const {
    className,
    style,
    download,
    onClickdownload,
    content,
    media,
    datetime,
    listIndex,
    type = 'iconlist',
    downloadIcon,
    briefingName,
    shortConSlateRichText,
    onClickdownloadIcon,
    showDelete,
    onClickDelete,
    objectId,
  } = props
  const mediaData = media || { filename: '', src: '' }
  const index = mediaData.filename.lastIndexOf('.')
  const ext = mediaData.filename.substr(index + 1)
  const isList = mediaData.filename || briefingName
  return type === 'list' ? (
    <StyledFileDetail className={className} style={style}>
      <div className="flex">
        <RenderIf isTrue={isList}>
          <StyledFileLeft
            onClick={() => {
              if (media) {
                FilePreview.preview([mediaData], 0)
              }
            }}
          >
            {renderIcon(ext)}
            <div className="text">{mediaData.filename || briefingName}</div>
            <StyledTime>{datetime}</StyledTime>
          </StyledFileLeft>
        </RenderIf>
        {shortConSlateRichText ? (
          <StyledContentHtml
            className={clsx({
              ellipsis: listIndex,
            })}
            dangerouslySetInnerHTML={{
              __html: renderConent(shortConSlateRichText),
            }}
          />
        ) : (
          <StyledContent>
            <div
              className={clsx(
                {
                  ellipsis: listIndex,
                },
                'text-gray-100 dark:text-dark-200'
              )}
              dangerouslySetInnerHTML={{
                __html: content && content.replace(/\n/g, '<br/>'),
              }}
            />
          </StyledContent>
        )}
      </div>
      <RenderIf isTrue={media}>
        <div
          className="flex justify-end cursor-pointer"
          onClick={(event) => {
            event.stopPropagation()
            onClickdownload(download)
          }}
        >
          <DownloadIcon width={18} height={18} fill="#8F8B8B" />
        </div>
      </RenderIf>
    </StyledFileDetail>
  ) : (
    <StyledIconFile
      className={className}
      style={style}
      onClick={() => {
        if (media) {
          FilePreview.preview([mediaData], 0)
        }
      }}
    >
      {renderIcon(ext)}
      <div className="flex items-center justify-between mt-5">
        <div className="text">
          <b>{mediaData.filename || briefingName}</b>
        </div>
        <RenderIf isTrue={downloadIcon && media}>
          <div
            className="cursor-pointer"
            onClick={(event) => {
              event.stopPropagation()
              onClickdownloadIcon(media)
            }}
          >
            <DownloadIcon width={18} height={18} fill="#8F8B8B" />
          </div>
        </RenderIf>
        <RenderIf isTrue={showDelete}>
          <div
            className="cursor-pointer ml-2"
            onClick={(event) => {
              event.stopPropagation()
              onClickDelete(objectId)
            }}
          >
            <DeleteIcon width={18} height={18} fill="#8F8B8B" />
          </div>
        </RenderIf>
      </div>
      <RenderIf isTrue={datetime}>
        <StyledTime>{datetime}</StyledTime>
      </RenderIf>
    </StyledIconFile>
  )
}

// 参数类型
File.propTypes = {
  style: PropTypes.shape({}),
  className: PropTypes.string,
  download: PropTypes.bool,
  content: PropTypes.node,
  media: PropTypes.shape({}),
  type: PropTypes.string,
  datetime: PropTypes.string,
  listIndex: PropTypes.number,
  downloadIcon: PropTypes.bool,
}
File.defaultProps = {
  className: undefined,
  style: undefined,
  download: undefined,
  content: undefined,
  media: undefined,
  type: undefined,
  datetime: undefined,
  listIndex: undefined,
  downloadIcon: undefined,
}
export default File
